import React from "react";
export function Closing() {
  return <section className="mx-auto max-w-5xl px-6 py-16 text-center sm:py-24" data-id="element-23" data-mp="1345qprpv027a">
      <h2 className="mb-6 font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-24" data-mp="3szpy7wdes92m">
        Empezá a trabajar en tu propio ebook
      </h2>
      <p className="mx-auto mb-7 max-w-xl text-lg leading-relaxed text-soft" data-id="element-25" data-mp="3f7jqmyobnaes">
        Sumate a la comunidad y avanzá con formación y dos asesorías semanales conmigo.
      </p>
      <a href="#unirme" className="inline-flex min-h-12 items-center justify-center rounded-xl bg-accent px-7 py-4 text-base font-bold text-black transition-colors duration-150 hover:bg-accent-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-ink" data-id="element-26" data-mp="359vjtadfycg9">
        Quiero entrar con precio fundador
      </a>
    </section>;
}